module.exports = __webpack_public_path__ + "img/w6_banner.3d1e93ae.jpg";